import React, { FC, useCallback } from 'react';
import styles from '../index.module.scss';
import { useTranslation } from 'react-i18next';
import { Button } from 'src/common';
import { ProcurementsDisplay, OverviewQp } from 'src/models/procurements/types';
import { useSetOverviewQp } from 'src/models/procurements/hooks';

interface IProps {}

export const EmptyStarredMessage: FC<IProps> = () => {
  const { t } = useTranslation();
  const setOverviewQp = useSetOverviewQp();

  const onGoToScreening = useCallback(() => {
    setOverviewQp({ [OverviewQp.Tab]: ProcurementsDisplay.MATCHED });
  }, [setOverviewQp]);

  return (
    <div className={styles.content}>
      <div className={styles.subTitle}>{t('Tenders.starredListEmpty')}</div>
      <div className={styles.text}>
        {t('Tenders.goTo')}{' '}
        <Button onClick={onGoToScreening} type="link">
          {t('Tenders.tenders')}
        </Button>
      </div>
    </div>
  );
};

export default EmptyStarredMessage;
